import React from 'react';
import { Chip, Typography, LinearProgress, Avatar as MUIAvatar, Button } from '@mui/material';
import { ICourseData } from '../../types/course-data';
import Avatar from '../shared/avatar';
import { adaptCourseTypeText } from 'src/shared/utils/adapt-course-type-text';
import { MarkdownRenderer } from 'src/shared/components/markdown-renderer';
import ProgressBar from './progress-bar';
// import { AddToFavourites } from '../elements/favourites-button';

interface DialogContentMobileProps {
  lessons?: ICourseData['lessons'];
  title?: string;
  description?: string;
  progressValue?: number;
  label?: string;
  children?: React.ReactNode;
}

const MetadataItem: React.FC<DialogContentMobileProps> = ({ label, children }) => {
  return (
    <div className="flex flex-col gap-2 items-start w-full">
      <Typography variant="body-small-500" className="truncate" component="p" color="textSecondary">
        {label}
      </Typography>
      {children}
    </div>
  );
};

export const DialogContentMobile: React.FC<DialogContentMobileProps & Partial<ICourseData>> = ({
  title,
  description,
  progressValue,
  videoCount,
  level,
  genres,
  duration,
  instructors,
  courseType,
  highlighted,
  children,
  lessons,
}) => {
  return (
    <div className="space-y-4">
      <Typography variant="h5" component="h5">
        {title}
      </Typography>
      <div className="flex flex-col gap-3 pb-4">
        <div className="flex gap-x-4">
          <MetadataItem label="Lezioni">
            {videoCount !== undefined && (
              <Chip
                label={
                  <Typography variant="button-s">
                    {videoCount} lezion{videoCount !== 1 ? 'i' : 'e'}
                  </Typography>
                }
                size="small"
                avatar={<MUIAvatar src="/assets/images/play-arrow-filled.png" className="mr-0" />}
                sx={{
                  background: '#54566870',
                }}
              />
            )}
          </MetadataItem>
          <MetadataItem label="Livello">
            <Chip
              label={<Typography variant="button-s">{level}</Typography>}
              size="small"
              avatar={<MUIAvatar src="/assets/images/play-arrow-filled.png" className="mr-0" />}
              sx={{
                background: '#54566870',
              }}
            />
          </MetadataItem>
          <MetadataItem label={`Durata ${courseType ? adaptCourseTypeText(courseType) : ''}`}>
            <Typography variant="caption-500" className="text-text-primary">
              {duration}
            </Typography>
          </MetadataItem>
        </div>
        {Array.isArray(genres) && genres.length > 0 && (
          <MetadataItem label="Genere">
            <span className="space-x-2">
              {genres.map((genre, index) => (
                <Chip
                  key={index}
                  label={<Typography variant="button-s">{genre}</Typography>}
                  size="small"
                  color="default"
                  variant="outlined"
                  className="self-start"
                />
              ))}
            </span>
          </MetadataItem>
        )}
      </div>
      <Typography variant="body-500" color="textSecondary">
        <MarkdownRenderer markdown={description} />
      </Typography>
      <MetadataItem label="Insegnante">
        <div className="flex items-center text-text-primary">
          <Avatar instructors={instructors as ICourseData['instructors']} courseType={courseType} />
          {/** TODO @Renzo Check the fix
           * Property 'highlighted' does not exist on type 'IntrinsicAttributes & AvatarProps'.
           */}
        </div>
      </MetadataItem>
      <div className="flex justify-between gap-4">
        <ProgressBar lessons={lessons} />
      </div>
      {children}
      {/* <AddToFavourites /> */}
    </div>
  );
};
